import { useState } from 'react';
import { useConvexSiteUrl } from './useConvexSiteUrl';
import { ClientInfo } from '../helpers/client-fingerprint';

interface SubscribeResult {
  success: boolean;
  alreadySubscribed: boolean;
}

export const useSubscribeWithIP = () => {
  const [isLoading, setIsLoading] = useState(false);
  const convexSiteUrl = useConvexSiteUrl();

  const subscribe = async (email: string, clientInfo: ClientInfo, referrerEmail?: string): Promise<SubscribeResult> => {
    if (!convexSiteUrl) {
      throw new Error('Convex site URL not available');
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${convexSiteUrl}/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          clientInfo,
          referrerEmail
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        throw new Error(errorData.error || `HTTP ${response.status}`);
      }

      const result = await response.json();
      return result;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    subscribe,
    isLoading
  };
};
